import { createContext, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setTheme } from "../redux/slices/settingsSlice";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const dispatch = useDispatch();
  const theme = useSelector(state => state.settings.theme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    dispatch(setTheme(theme));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>;
};
